// extracted by mini-css-extract-plugin
module.exports = {"container":"_a9b6e9f","headerButtons":"_4d6d7fa","sliderButtons":"_00e89d8","tabSlider":"_14c2e86","innerSlider":"_1e12b30","cardContainer":"_88d70d6"};